import base from '../base.js'; // 导入接口域名列表
import axios from '../../plugins/service'; // 导入http中创建的axios实例


const code = {


	//追溯查询
	tracelist(query) {
		return axios.get(`${base.v1}/bymwechat/code/trace`, {
			params: query
			// headers: {'Authorization':query.code}
		});
	},


	// 页面模块配置
	pageConfig(query) {
		
		return axios.get(`${base.v1}/bymwechat/code/trace/page/v20251112/config`, {
		// return axios.get(`${base.v1}/bymwechat/code/trace/page/config-new`, {
			 
		// return axios.get(`${base.v1}/bymwechat/code/trace/page/config`, {
			params: query
		});
	},


	// 产品验证
	verifyProduct(query) {
		return axios.get(`${base.v1}/bymwechat/code/verify`, {
			params: query
			// headers: {'Authorization':query.code}
		});
	},

	//谢宏真道理 
	getArticles() {
		return axios.get(`${base.v1}/bymwechat/mommy/blog/xh`);
	},

	
	// 头部的广告  移动端
	AdvShow(query) {
		return axios.get(`${base.v1}/bymwechat/user/adv/show`, {
			params: query
		});
	},
	

	// 微信授权登录
	getwxlogin(query) {
		// return axios.get(`${base.v1}/openweixin/login/getwxloginurl?url=${query.url}`);
		return axios.get(`${base.v1}/openweixin/login/getwxloginurl?url=${query.url}&nick_name=贝因美官方号&scope=snsapi_base`);
	},

	// 授权登陆后验证身份
	loginauth(query) {
		return axios.get(`${base.v1}/openweixin/login/loginauth`, {
			params: query
		});
	},


	// 匿名用户换取token
	loginanonymous(query) {
		return axios.get(`${base.v1}/bymwechat/code/loginanonymous`, {
			params: query
		});
	},

	
	incodeCheck(query) {
		return axios.get(`${base.v1}/bymwechat/code/nm-check`, {
			params: query
		});
	},

	chargeIntegralC(data) {
		return axios.post(`${base.v1}/bymwechat/user/charge-integral-c`, data);
	},

	// 判断是否需要调用chargeIntegralC
	checkNeedCharge(code) {
		return axios.get(`${base.v1}/bymwechat/code/welfare/check?code=${code}`);
	},

	// 获取查询码的次数
	checkscannum(code) {
		return axios.get(`${base.v1}/bymwechat/code/checkscannum?code=${code}`);
	}
	
}

export default code;
